import type { Namespace } from "@/i18n/types";
import nsUploadEN from "./en";
import nsUploadJA from "./ja";

export const nsUpload = {
  name: "upload",
  locales: {
    ja: nsUploadJA,
    en: nsUploadEN,
  },
} satisfies Namespace<"upload", typeof nsUploadJA>;
